import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing-module';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';



import { 
  ApiService, 
  AppMaterialComponentsModule, 
  ContractorApiService, 
  ContractorGqlService, 
  ZipCodeApiService, 
  ZipCodeGqlService, 
  ContractorSearchModule,
  DialogSolutionDeployingComponent, 
  AppLoadService
} from '@ebb-v2/ebb-integration';
import { ContractorSearchAppComponent } from './app.component';
import { FlexLayoutModule, FlexModule } from '@ngbracket/ngx-layout';
import {  NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { APOLLO_PROVIDERS } from './apollo.config';
export function get_environ_settings(appLoadService: AppLoadService) {
  return () => appLoadService.getEnvironSettings();
}

@NgModule({ declarations: [
        ContractorSearchAppComponent,
        DialogSolutionDeployingComponent
    ],
    imports: [CommonModule,
        BrowserModule,
        FlexModule,
        FlexLayoutModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        CommonModule,
        AppMaterialComponentsModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        ContractorSearchModule,
        NgxMaskDirective, NgxMaskPipe], providers: [
        ApiService, provideNgxMask(),
        AppLoadService,
        { provide: APP_INITIALIZER, useFactory: get_environ_settings, deps: [AppLoadService], multi: true },
        { provide: ContractorApiService, useClass: ContractorGqlService },
        { provide: ZipCodeApiService, useClass: ZipCodeGqlService },
          ...APOLLO_PROVIDERS,
    ] , bootstrap: [ContractorSearchAppComponent],})
export class ContractorSearchAppModule {}






